import { getFormattedPhoneWithPhoneExt, getFullNameFromFio, getShortNameFromFio } from 'helpers/string'

import { TContact } from '../types'

export const getContactFullPhone = (contact: TContact | undefined): string => {
  if (!contact) {
    return ''
  }

  return getFormattedPhoneWithPhoneExt({
    phoneNumber: contact.phone,
    phoneExt: contact.phoneExt
  })
}

export const getContactFullName = (contact: TContact | undefined): string => {
  if (!contact) {
    return ''
  }

  return getFullNameFromFio({
    lastname: contact.lastname,
    firstname: contact.firstname,
    secondname: contact.secondname
  })
}

export const getContactShortName = (contact: TContact | undefined): string => {
  if (!contact) {
    return ''
  }

  return getShortNameFromFio({
    lastname: contact.lastname,
    firstname: contact.firstname,
    secondname: contact.secondname
  })
}
